import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: ${displayState?.enableFullWidth ? null : "280px"};
    border: 1px solid ${displayState?.disabled ? window?.settings?.secondary_color ?? '#04333b' : '#E3E3E3'};
    height: ${displayState?.height ? displayState.height : '42px'};
    border-radius: 8px;
    padding-left: 12px;
    width: ${displayState?.width ?? ''};
    background-color: ${displayState?.hasBackground ? '#FFFFFF' : ''};
    padding-right: 12px;
    
    &:hover {
      border: ${displayState?.disabled ? '' : `1px solid ${theme?.colour?.primary ?? "#1DBD6B"}`};
    }

    @media only screen and (min-width: 768px) {
      min-width: ${displayState?.enableFullWidth ? null : "320px"};
    }
  `}
`;

export default Wrapper(template);